<template>

  <TemplateBasic 
    v-bind:breadcrumb="breadcrumb"
    v-bind:permission="permission">

    <h3>Manual Reactivate</h3>
    
    <AppForm
      ref="pageForm" 
      v-bind:formParameter="PARAM"
      v-bind:permission="permission"
      v-on:form-input="onFormInput" >
      
    </AppForm>

    <TemplateFeedback ref="pageFeedback" />

    <TemplateButton v-on:click="onSaveButtonClick" type="button" class="btn btn-success">
      Submit
    </TemplateButton>

  </TemplateBasic>

</template>

<script>
import TemplateBasic from "@/components/Template/TemplateBasic";
import TemplateButton from "@/components/Template/TemplateButton";
import TemplateFeedback from "@/components/Template/TemplateFeedback";
import AppForm from "@/components/App/AppForm";
import helper from "@/components/Utility/Helper"

var querystring = require('querystring');
var moment = require('moment');

let commencementDateValidate = function(date) {
return true;
}

const PARAM = [
{
  key: 'carparkID',
  text: 'Car Park',
  form_select: {
    data: [],
    formatSelectOptionValue: (data) => data.id, 
    formatSelectOptionText: (data) => data.carparkCode ? `${data.carparkCode} - ${data.name}` : data.name,
  },
  form_chosen: true,
  form_edit_input_attr: {
    disabled: true,
  },
},
{
  key: 'licenseID',
  text: 'Parking License',
  form_select: {
    data: [],
    formatSelectOptionText: option => {
      let text = helper.plFormPLNum(option.licenseOperatorNum, option.carparkID);
      let customer = option['_customer'];
      text += customer ? ` - ${customer.name} (${customer.nationalID})` : '';
      return text;
    },
  },
  form_chosen: true,
  form_edit_input_attr: {
    disabled: true,
  },
},
{
  key: '_lease',
  text: 'Lease',
  form_select: {
    data: [],
    formatSelectOptionText: option => {
      if(typeof option === 'string') {
        return option;
      }
      let text = `${option['leaseZone']} - ${option['leaseProductName']} - ${option['parkerName']} `;
      // if(option['isParkAide']) {
      //   let parkaideStatus = '(Passcard: ParkAide Blocked)'
      //   // if(option['status'] === 'Active' || option['status'] === 'Pending Reactivate') {
      //   if(new moment() > helper.parseDateTime(option['commencementDate'])) {
      //     if(!option['isBlock']) {
      //       parkaideStatus = '(Passcard: ParkAide Active)';
      //     }
      //   }
      //   // }
      //   text += parkaideStatus;
      // } else {
      //   text += option['leasePasscard'] ? '(Passcard: ' + option['leasePasscard'] + ')' : '';
      // }
      return text;
    },
  },
  form_edit_hide: true,
  form_input_attr: {
    'multiple' : true,
    'data-placeholder': 'Select product subscription',
  },
  form_chosen_multiple: true,
},
{
  key: 'reactivateDate',
  text: 'Reactivate Date',
  form_datepicker: true,
  // form_datepicker: {
  //   beforeShowDay: function(date) {
  //     return commencementDateValidate(date);
  //   },
  // },
},
];

const PARAM_MAP = helper.transformParamToMap(PARAM);

export default {
name: "PageManualReactivate",
components: {
  TemplateBasic,
  TemplateButton,
  TemplateFeedback,
  AppForm,
},
data () {
  return {
    permission : null,
    breadcrumb : [
      { name: 'Home', url: helper.WEB_URL },
      { name: 'Adminstration' },
      { name: 'Manual Reactivate' },
    ],

    PARAM,
    PARAM_MAP,
  }
},
mounted() {
  if(!helper.hasViewPermission(this.permission = helper.getPermission(this))) {
    return;
  }
  
  this.$refs['pageForm'].setForm(true);
  this.hideFormFromKey('carparkID');
  this.loadCustomer();
},
methods: {
  hideFormFromKey(key) {
    if(key === null) {
      this.pageShowSumbit = true;
    }

    let hide = false;
    this.PARAM.forEach(parameter => {
      if(parameter.key === key) {
        hide = true;
      }

      if(hide) {
        parameter.form_hide = hide;
        return;
      }

      parameter.form_hide = hide;
    });
  },

  loadCustomer() {
    this.$refs['pageFeedback'].setFeedbackLoading('Loading profile data...');
    this.$http
      .get(
        helper.SERVER_URL + '/api2/customer',
        helper.createAxiosConfig()
      )
      .then(response => {
        let resultMeta = helper.processAxiosResponse(this, response);
        this.$refs['pageFeedback'].setFeedbackMessage();
        this.pageCustomer = response.data;
        this.loadZone();
      })
      .catch(error => {
        this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', 'profile data'));
      });
  },
  loadZone() {
    this.$refs['pageFeedback'].setFeedbackLoading('Loading car park zone data...');
    this.$http
      .get(
        helper.SERVER_URL + '/api2/zone',
        helper.createAxiosConfig()
      )
      .then(response => {
        let resultMeta = helper.processAxiosResponse(this, response);
        this.$refs['pageFeedback'].setFeedbackMessage();
        this.pageZone = response.data;
        this.loadCarpark();
      })
      .catch(error => {
        this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', 'car park zone data'));
      });
  },

  loadCarpark() {
    this.$refs['pageFeedback'].setFeedbackLoading('Loading car park data...');
    this.$http
      .get(
        helper.SERVER_URL + '/api2/carpark',
        helper.createAxiosConfig()
      )
      .then(response => {
        let resultMeta = helper.processAxiosResponse(this, response);
        this.$refs['pageFeedback'].setFeedbackMessage();

        // helper.inputSelectSetOption(this.PARAM_MAP['carparkID'], this.pageCarpark = response.data);
        // this.loadZone();

        this.pageCarpark = response.data

        helper.inputSelectSetOption(this.PARAM_MAP['carparkID'], response.data);
        let formData = this.$refs['pageForm'].formData;
        formData['carparkID'] = this.$route.query.carparkID || formData['carparkID'];
        formData['licenseID'] = this.$route.query.licenseID || formData['licenseID'];
        this.hideFormFromKey('licenseID');
        if(formData['carparkID']) {
          this.loadSeason();
        }
      })
      .catch(error => {
        this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', 'car park data'));
      });
  },
  loadSeason() {
    this.hideFormFromKey('licenseID');

    let feedbackItem = 'product data';
    this.$refs['pageFeedback'].setFeedbackLoading('Loading ' + feedbackItem);
    this.$http
      .get(
        helper.SERVER_URL + '/api2/carpark/' + this.$refs['pageForm'].formData['carparkID'] + '/season/',
        helper.createAxiosConfig()
      )
      .then(response => {
        let resultMeta = helper.processAxiosResponse(this, response);
        if(response.data && response.data.length > 0) {
          this.$refs['pageFeedback'].setFeedbackMessage();
          this.pageSeason = response.data;
          this.loadLicense();
        } else {
          this.$refs['pageFeedback'].setFeedbackError('No ' + feedbackItem + ' available.');
        }
      })
      .catch(error => {
        this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', feedbackItem));
      })
  },
  loadLicense() {
    this.hideFormFromKey('licenseID');
    let formData = this.$refs['pageForm'].formData;

    let url = helper.SERVER_URL;
    url += '/api2/carpark/' + formData['carparkID'] + '/license/';
    
    let feedbackItem = 'parking license data'
    this.$refs['pageFeedback'].setFeedbackLoading('Loading ' + feedbackItem);
    this.$http
      .get(
        url,
        helper.createAxiosConfig()
      )
      .then(response => {
        let resultMeta = helper.processAxiosResponse(this, response);
        this.$refs['pageFeedback'].setFeedbackMessage();

        this.pageLicense = response.data;

        response.data.forEach(k => {
          k['_carpark'] = this.pageCarpark.find(j => j.id === k.carparkID);
          k['_customer'] = this.pageCustomer.find(j => j.id === k.customerID);
        });

        helper.inputSelectSetOption(this.PARAM_MAP['licenseID'], response.data);
        this.hideFormFromKey();

        this.loadParker()
      })
      .catch(error => {
        this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', feedbackItem));
      })
  },

  loadParker() {
    this.hideFormFromKey('sectionProductSubscription');

    let customerID = helper.inputSelectFindOption(this.PARAM_MAP['licenseID'], this.$refs['pageForm'].formData['licenseID']).customerID;

    let feedbackItem = 'parker data';
    this.$refs['pageFeedback'].setFeedbackLoading('Loading ' + feedbackItem);
    this.$http
      .get(
        helper.SERVER_URL + '/api2/customer/' + customerID + '/parker/',
        helper.createAxiosConfig()
      )
      .then(response => {
        let resultMeta = helper.processAxiosResponse(this, response);
        if(response.data && response.data.length > 0) {
          this.$refs['pageFeedback'].setFeedbackMessage();
          this.pageParker = response.data;
          this.loadLicenseLease();
        } else {
          this.$refs['pageFeedback'].setFeedbackError('No ' + feedbackItem + ' available.');
        }
      })
      .catch(error => {
        this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', feedbackItem));
      })
  },
  loadLicenseLease() {
    this.hideFormFromKey('_lease');

    let feedbackItem = 'parking license lease data'
    this.$refs['pageFeedback'].setFeedbackLoading('Loading ' + feedbackItem);
    this.$http
      .get(
        helper.SERVER_URL + '/api2/license/' + this.$refs['pageForm'].formData['licenseID'] + '/lease/?current=1',
        helper.createAxiosConfig()
      )
      .then(response => {
        let resultMeta = helper.processAxiosResponse(this, response);
        this.$refs['pageFeedback'].setFeedbackMessage();
        this.latestLease = response.data;
        
        let earliestStopBillDate = 0

        response.data = response.data.filter(leaseData => {
          if(leaseData['stopBillDate']) {
            let season = this.pageSeason.find(k => helper.compareID(k.id, leaseData['seasonID'])) || {};
            leaseData['leaseProductName'] = season['name']
            leaseData['_season'] = season;

            let zone = this.pageZone.find(k => helper.compareID(k.id, (season || {})['zoneID']));
            leaseData['leaseZone'] = (zone || {}).name;

            let parker = this.pageParker.find(k => k['id'] === leaseData['parkerID'])
            leaseData['_parker'] = parker;
            leaseData['parkerName'] = parker['name'];

            if(!earliestStopBillDate || earliestStopBillDate > leaseData['stopBillDate']) {
              earliestStopBillDate = leaseData['stopBillDate']
            }

            return true
          }
        });
        earliestStopBillDate = moment.unix(earliestStopBillDate).startOf('month').unix()

        if(response.data.length === 0) {
          this.$refs['pageFeedback'].setFeedbackError('No stop bill subscription available');
          return;
        }

        try {
          // commencementDateValidate = function(date) {
          //   if(date.getTime() < earliestStopBillDate * 1000) {
          //     return false;
          //   }
          //   return true;
          // }
          $('#jt-form-input-reactivateDate').datepicker('update');
        } catch (e) {
        }

        this.pageLease = response.data
        helper.inputSelectSetOption(this.PARAM_MAP['_lease'], [].concat('All Subscription', this.pageLease));

        this.hideFormFromKey();
      })
      .catch(error => {
        this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', feedbackItem));
      })
  },
  
  onSaveButtonClick() {
    if(!this.$refs['pageForm'].validateForm()) {

      let formData = this.$refs['pageForm'].formData;
      formData['date'] = helper.parseDateTime(formData['reactivateDate']).unix();
      formData['leases'] = []

      this.pageLease.forEach(k => {
        if(formData['_lease'].includes('All Subscription') || formData['_lease'].includes(String(k['id']))) {
          let stopBillMonth = helper.parseDateTime(k['stopBillDate']).startOf('month')
          // if(stopBillMonth.unix() > formData['date']) {
          //   let text = `${k['leaseZone']} - ${k['leaseProductName']} - ${k['parkerName']} `;
          //   this.$refs['pageFeedback'].setFeedbackError(`Subscription ${text} stop bill date is ${stopBillMonth.format('DD/MM/YYYY')}, reactivate date ${helper.parseDateTime(formData['reactivateDate']).format('DD/MM/YYYY')} is earlier than stop bill date`);
          //   return
          // }

          formData['leases'].push(k['id'])
        }
      });

      this.$refs['pageFeedback'].setFeedbackLoading('Reactivate subscription...');
      this.$http
        .post(
          helper.API_URL + '/api2/license/reactivate',
          querystring.stringify(formData),
          helper.createAxiosFormConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          this.$refs['pageFeedback'].setFeedbackMessage('Successfully reactivate subscription');
          return true;
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'reactivate', 'subscription'));
        })
    }
  },

  onFormInput(formData, formParameter, input) {
    if(formParameter.key === 'carparkID') {
      formData['licenseID'] = null;
      formData['_lease'] = [];
      formData['lease'] = [];
      this.loadSeason();
    } else if(formParameter.key === 'licenseID') {
      formData['_lease'] = [];
      formData['lease'] = [];
      this.loadParker();
    } else if(formParameter.key === '_lease') {
      let pairIDlist = []
      if(!formData['_lease'].includes('All Subscription')) {
        this.pageLease.forEach(k => {
          if(formData['_lease'].includes(String(k['id']))) {
            // if(k['stopBillDate'] > formData['date']) {
            //   let text = `${k['leaseZone']} - ${k['leaseProductName']} - ${k['parkerName']} `;
            //   this.$refs['pageFeedback'].setFeedbackError(`Subscription ${text} stop bill date is ${helper.parseDateTime(formData['stopBillDate']).format('DD/MM/YYYY')}, reactivate date ${helper.parseDateTime(formData['reactivateDate']).format('DD/MM/YYYY')} is earlier than stop bill date`);
            //   return
            // }

            if(k['pairID']) {
              if(!pairIDlist.includes(k['pairID'])) {
                pairIDlist.push(k['pairID'])
              }
            }
          }
        });

        // // will cause tandem cannot remove, as everytime can only remove one subscription
        // // the other tandem will still be in and cause the removed one back in selection
        // this.pageLease.forEach(k => {
        //   if(pairIDlist.includes(k['pairID'])) {
        //     if(!formData['_lease'].includes(String(k['id']))) {
        //       formData['_lease'].push(String(k['id']))
        //     }
        //   }
        // });
      }
    }
  },

  hasAddOrEditPermission() {
    return this.pageIsAdd ? helper.hasAddPermission(this.permission) : helper.hasEditPermission(this.permission);
  },
  hasDeletePermission() {
    return helper.hasDeletePermission(this.permission);
  },
},
};
</script>



// WEBPACK FOOTER //
// src/components/Page/Manual/PageManualReactivate.vue